export default {
      id: "youtube-usage",
      viewBox: "0 0 17 13",
      url: "../../assets/" + "sprite.svg#youtube-usage",
      toString: function () {
        return this.url;
      }
    }